import { Drawer, Box, type DrawerProps } from '@mantine/core'
import { useResizableDrawer } from '@/hooks/useResizableDrawer'

interface ResizableDrawerProps extends Omit<DrawerProps, 'size'> {
  storageKey: string
  defaultWidth?: number
  minWidth?: number
}

export function ResizableDrawer({
  storageKey,
  defaultWidth = 700,
  minWidth = 400,
  opened,
  children,
  ...rest
}: ResizableDrawerProps) {
  const { width, onResizeStart } = useResizableDrawer({
    storageKey,
    defaultWidth,
    minWidth,
  })

  return (
    <>
      {opened && (
        <Box
          className="drawer-resize-handle"
          onMouseDown={onResizeStart}
          style={{
            position: 'fixed',
            top: 0,
            right: width,
            width: 6,
            height: '100%',
            cursor: 'ew-resize',
            zIndex: 300,
          }}
        />
      )}
      <Drawer opened={opened} size={width} {...rest}>
        {children}
      </Drawer>
    </>
  )
}
